import AxiosRequest from "./utils/AxiosRequest";
import Log from "./utils/Log";
import { Token } from "./utils/Token";

let mmChatLoader = {
  init: function() {
    Token.set(document.token);
    AxiosRequest.get("/dist/manifest.json")
      .then(function(response) {
        let assets = response.data;
        let launcher = document.createElement("script");
        launcher.src = __APP_BASE_URL__ + "/dist/" + assets["chat_launcher.js"];
        document.body.appendChild(launcher);
      })
      .catch(function(error) {
        Log.info(error);
      });
  }
};

mmChatLoader.init();
